import { ApplicationOtherStatusesScreen } from "@/interactors/ApplicationOtherStatusesScreen";

export default function OtherStatuses() {
  return <ApplicationOtherStatusesScreen />;
}
